angular.module('unergie.main')
.factory('UserNotificationService', (MetaWatcher, BoFeaturesService) => {
    const notifications = []

    const addNotif = (notif) => {
        if (!BoFeaturesService.isFeatureOn('userNotifications')) {
            return
        }
        notif.idNotif = `${Date.now()}${Math.floor(Math.random() * 1000)}`
        notif.date = moment()
        notifications.unshift(notif)
        MetaWatcher.notif('USER_NOTIFS')
    }

    const removeNotif = (notif) => {
        _.remove(notifications, { idNotif: notif.idNotif })
        MetaWatcher.notif('USER_NOTIFS')
    }

    const listNotif = () => notifications

    const removeAll = (number) => {
        notifications.splice(0, number || notifications.length)
        MetaWatcher.notif('USER_NOTIFS')
    }

    return {
        addNotif,
        removeNotif,
        listNotif,
        removeAll,
    }
})
